import { ActivationPayload, AuthenticationPayload } from '@dev/ee-api/ee-api-models';

import {
    Resend2FACodeAction,
    AuthActionTypes,
    Resend2FACodeSuccessAction,
    AuthErrorAction,
    ResendActivationEmailAction,
    ResendActivationEmailSuccessAction,
    ResendActivationEmailErrorAction,
    ResendActivationEmailUserAction,
} from './types';

export const Resend2FACode = (authPayload: AuthenticationPayload): Resend2FACodeAction => ({
    type: AuthActionTypes.RESEND_2FA,
    payload: authPayload,
    meta: {
        thunk: true,
    },
});

export const Resend2FACodeSuccess = (meta: Record<string, unknown>): Resend2FACodeSuccessAction => ({
    type: AuthActionTypes.RESEND_2FA_SUCCESS,
    meta,
});

export const AuthError = (meta: Record<string, unknown>): AuthErrorAction => ({
    type: AuthActionTypes.AUTH_ERROR,
    error: true,
    meta,
});

export const ResendActivationEmail = (payload: ActivationPayload): ResendActivationEmailAction => ({
    type: AuthActionTypes.RESEND_ACTIVATION_EMAIL,
    payload,
    meta: {
        thunk: true,
    },
});

export const ResendActivationEmailSuccess = (meta: Record<string, unknown>): ResendActivationEmailSuccessAction => ({
    type: AuthActionTypes.RESEND_ACTIVATION_EMAIL_SUCCESS,
    meta,
});

export const ResendActivationEmailError = (
    error: Record<string, unknown>,
    meta: Record<string, unknown>
): ResendActivationEmailErrorAction => ({
    type: AuthActionTypes.RESEND_ACTIVATION_EMAIL_ERROR,
    payload: error,
    error: true,
    meta,
});

export const ResendActivationEmailUser = (
    payload: ActivationPayload,
    previousMeta: Record<string, unknown>
): ResendActivationEmailUserAction => ({
    type: AuthActionTypes.RESEND_ACTIVATION_EMAIL_USER,
    payload,
    previousMeta,
    meta: {
        thunk: true,
    },
});
